import { GatsbyBrowser } from "gatsby";

const checkRoutes = (pathname: string) => !!(pathname.includes('career/') || pathname.includes('vacancies/'))

export const shouldUpdateScroll: GatsbyBrowser['shouldUpdateScroll'] = (args) => 
    checkRoutes(args.routerProps.location.pathname) ? args.prevRouterProps?.location.pathname !== args.routerProps.location.pathname : true
